import create from "zustand";

import { Profile } from "@/types/profile.types";

type ProfileStore = {
  profile: Profile | null;
  setProfile: (profile: Partial<Profile>) => void;
  clearProfile: () => void;
};

const useProfileStore = create<ProfileStore>((set) => ({
  profile: null,

  setProfile: (profile: Partial<Profile>) =>
    set((state) => ({
      profile: { ...(state.profile ?? {}), ...profile } as Profile,
    })),

  clearProfile: () => set({ profile: null }),
}));

/**
 * Returns the profile store data if a profile exists. Use this to avoid having to check for falsy values when you know a profile exists in a given context.
 * @returns The profile store data
 */
const getProfileData = (): Profile => {
  const { profile } = useProfileStore.getState();

  if (!profile) {
    throw new Error("Profile does not exist");
  }

  return {
    ...profile,
  };
};

export { getProfileData, useProfileStore, type ProfileStore };
